/* ==========================================================================
   CRO Comida de Dragão — Botão "Adicionar" da recomendação do drawer
   O card é renderizado no servidor (snippet cart-drawer-reco.liquid).
   Aqui só tratamos o clique em "Adicionar": adiciona ao carrinho e
   re-renderiza o drawer (padrão Dawn), o que atualiza a própria recomendação.
   ========================================================================== */
(function () {
  function onAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var cartDrawer = document.querySelector('cart-drawer');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';

    var sections = cartDrawer && cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state && state.sections) {
          cartDrawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cro-reco__add') : null;
    if (btn) onAdd(btn);
  });
})();
